
import DragAndDrop from './DragDrop';
import Slider from './Slider';

export const StateCredentialFile = ({
  // editMode,
  credential,
  license,
  setLicenses,
  credentialType,
// eslint-disable-next-line arrow-body-style
}) => {

  return (
    <div
      style={{
        border: '1px dashed #cecece',
        borderRadius: '5px',
        fontWeight: 400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      {credential && credential?.files?.length > 0 ? (
        <Slider
          credential={credential}
          license={license}
          setLicenses={setLicenses}
          credentialType={credentialType}
        />
      ) : (
        <DragAndDrop
          credential={credential}
          license={license}
          setLicenses={setLicenses}
          credentialType={credentialType}
        />
      )}
    </div>
  );
};
